<div class="w-screen absolute z-50" style="background: #FFFFFF;">
    <app-header-dashboard></app-header-dashboard>
</div>
<div class="w-screen absolute" style="margin-top: 70px; z-index: 20;">
    <app-archive-header></app-archive-header>
</div>

<div class="h-full">
    <div *ngIf="!isSponsorEmpty" class="grid grid-cols-12 gap-5 py-28 px-20">
        <div class="col-span-4" *ngIf="!isEventLoading">
            <div class="bg-white border border-gray-300 rounded relative">
                <div class="bg_events_sponsors h-100-px">
                    <img src="assets/images/bg-event_sponsors.png" class="absolute top-0 left-0 h-88-px">
                    <img src="assets/images/bg-event_sponsors1.png" class="absolute top-0 right-0 h-88-px">
                    <div class="text-center py-8 text-black rubik font-semibold fs-22-px not-italic">
                        Our event sponsors
                    </div>
                </div>
                <div class="bg_event_tab" *ngFor="let sponsor_list of sponsor"> 
                    <div class="px-5 py-2 text-navy rubik font-semibold not-italic fs-14-px">
                        {{sponsor_list.name}}
                    </div>
                    <ng-container *ngFor="let sponsor_company of sponsor_list.sponsors">
                        <!-- *ngIf="sponsor_list.id==selected_sponsor" -->
                        <ng-container >
                            <!-- {{sponsor_company.id == selected_sponsor}} -->
                            <div class="flex items-center bg-white cursor-pointer" [ngClass] = "{'bg_border_tab_active' : sponsor_company.id == selected_sponsor}" (click)="setSponsor(sponsor_company)">
                                <div class="px-5 py-5">
                                    <img src="{{sponsor_company.logo_url ? sponsor_company.logo_url : 'assets/empty_states/profile_avatar2.png'}}" class="rounded w-50-px h-50-px">
                                </div>
                                <div class="text-gray900 rubik font-medium not-italic fs-16-px">
                                    {{sponsor_company.company}}
                                </div>
                                <div class="ml-auto px-5 py-5">
                                    <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.16406 20.1296L7.93406 21.8996L17.8341 11.9996L7.93406 2.09961L6.16406 3.86961L14.2941 11.9996L6.16406 20.1296H6.16406Z" fill="#3B67B2"/>
                                    </svg>   
                                </div>
                            </div>
                        </ng-container>

                        <!-- <ng-container *ngIf="sponsor_list.id!=selected_sponsor">
                            <div  (click)="setSponsor(sponsor_list.id)" class="flex items-center bg-white cursor-pointer" style="border-bottom: 1px solid #ded8d8">
                                <div class="px-5 py-5">
                                    <img src="{{sponsor_company.logo_url ? sponsor_company.logo_url : 'assets/empty_states/profile_avatar2.png'}}" class="rounded w-50-px h-50-px">
                                </div>
                                <div  class="text-gray900 rubik font-medium not-italic fs-16-px">
                                    {{sponsor_company.company}}
                                </div>
                            </div>
                        </ng-container> -->
                    </ng-container>        

            
                </div> 
            </div>
        </div>

        <!-- skeleton -->
        <ng-container *ngIf="isEventLoading">
            <div class="col-span-4">
                <div class="bg-white border border-gray-300 w-full h-full rounded relative">
                    <div class="bg_events_sponsors h-100-px">
                        <img src="assets/images/bg-event_sponsors.png" class="absolute top-0 left-0 h-88-px">
                        <img src="assets/images/bg-event_sponsors1.png" class="absolute top-0 right-0 h-88-px">
                        <div class="text-center py-8 text-black rubik font-semibold fs-22-px not-italic">
                            Our event sponsors
                        </div>
                    </div>
                    <div class="bg_event_tab py-2"> 
                        <div class="h-30-px w-240-px px-5 py-2 rounded-full">
                            <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                        </div>
                    </div>  
                    <div class="flex items-center bg_border_tab_active">
                        <div class="px-5 py-5">
                            <div class="h-50-px w-50-px  rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
                        <div class="h-15-px w-full px-5  rounded-full">
                            <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                        </div>
                    </div>
    
                    <div class="bg_event_tab px-5 py-5"> 
                        <div class="h-15-px w-200-px rounded-full">
                            <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                        </div>
                    </div>  

                    <div class="flex items-center" *ngFor="let item of [1,2,3]" style="border-bottom: 1px solid #ded8d8">
                        <div class="px-5 py-5">
                            <div class="h-50-px w-50-px  rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
                        <div class="h-15-px w-full px-5  rounded-full">
                            <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                        </div>
                    </div>

                    <div class="bg_event_tab px-5 py-5"> 
                        <div class="h-15-px w-200-px rounded-full">
                            <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                        </div>
                    </div>  

                    <div class="flex items-center" *ngFor="let item of [1,2,3]" style="border-bottom: 1px solid #ded8d8">
                        <div class="px-5 py-5">
                            <div class="h-50-px w-50-px  rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
                        <div class="h-15-px w-full px-5  rounded-full">
                            <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                        </div>
                    </div>
    
                 
                   
                </div>
            </div>
        </ng-container>
    
        <div class="col-span-8" *ngIf="!isEventLoading">
            <div class="bg-white border border-gray-300 rounded" *ngIf="about_sponsor">
                <div class="flex items-center px-5 py-5">
                    <div>
                        <img src="{{about_sponsor.logo_url}}" class="rounded w-60-px h-60-px">
                    </div>
                    <div class="ml-5 text-gray900 rubik font-semibold not-italic fs-16-px">
                        About this sponsor
                    </div>
                </div>
                <hr class="w-full">
                <div class="grid grid-cols-12 bg-alternate px-5 py-4">
                    <div class="col-span-4">
                        <div class="text-main-gray rubik font-normal not-italic fs-14-px">
                            Website
                        </div>
                    </div>

                    <div class="col-span-8">
                        <div class="text-blue rubik font-normal not-italic fs-14-px">
                           {{about_sponsor.social_media_links.website ? about_sponsor.social_media_links.website : 'No website shared'}}
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-12 bg-white px-5 py-4">
                    <div class="col-span-4">
                        <div class="text-main-gray rubik font-normal not-italic fs-14-px">
                        Email address
                        </div>
                    </div>

                    <div class="col-span-8">
                        <div class="text-navy rubik font-normal not-italic fs-14-px">
                            {{about_sponsor.social_media_links.email ? about_sponsor.social_media_links.email : 'No email shared'}}
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-12 bg-alternate px-5 py-4">
                    <div class="col-span-4">
                        <div class="text-main-gray rubik font-normal not-italic fs-14-px">
                        Phone
                        </div>
                    </div>

                    <div class="col-span-8">
                        <div class="text-navy rubik font-normal not-italic fs-14-px">
                            {{about_sponsor.social_media_links.phone ? about_sponsor.social_media_links.phone : 'No phone shared'}}
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-12 bg-white px-5 py-4">
                    <div class="col-span-4">
                        <div class="text-main-gray rubik font-normal not-italic fs-14-px">
                        Social Links
                        </div>
                    </div>

                    <div class="col-span-8">
                        <div class="flex flex-col space-y-2">
                            <div class="flex items-center">
                                <div class="social-media-icon fb mgr-5">
                                    <i class="fab fa-facebook-f text-white"></i>
                                </div>
                                <div class="text-navy rubik font-normal not-italic fs-14-px">
                                    {{about_sponsor.social_media_links.facebook ? about_sponsor.social_media_links.facebook : 'No facebook shared'}}
                                </div>
                            </div>
                            <div class="flex items-center">
                                <div class="social-media-icon ln mgr-5">
                                    <i class="fab fa-linkedin-in text-white"></i>
                                </div>
                                <div class="text-navy rubik font-normal not-italic fs-14-px">
                                    {{about_sponsor.social_media_links.linkedln ? about_sponsor.social_media_links.linkedln : 'No linkedln shared'}}
                                </div>
                            </div>
                            <div class="flex items-center">
                                <div class="social-media-icon ln mgr-5">
                                    <i class="fab fa-twitter text-white"></i>
                                </div>
                                <div class="text-navy rubik font-normal not-italic fs-14-px">
                                    {{about_sponsor.social_media_links.twitter ? about_sponsor.social_media_links.twitter : 'No twitter shared'}}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="grid grid-cols-12 bg-alternate px-5 py-4">
                    <div class="col-span-4">
                        <div class="text-main-gray rubik font-normal not-italic fs-14-px">
                        Description
                        </div>
                    </div>

                    <div class="col-span-8">
                        <div class="text-navy rubik font-normal not-italic fs-14-px text-justify">
                            {{about_sponsor.profile ? about_sponsor.profile : 'No description shared'}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- skeleton -->
        <ng-container *ngIf="isEventLoading">
            <div class="col-span-8">
                <div class="bg-white border border-gray-300 rounded">
                    <div class="flex items-center px-5 py-5">
                        <div>
                            <img src="assets/images/Circular.png" class="rounded w-50 h-50">
                        </div>
                        <div class="ml-5 text-gray900 rubik font-semibold not-italic fs-16-px">
                            About this sponsor
                        </div>
                    </div>
                    <hr class="w-full">
                    <div class="grid grid-cols-12 bg-alternate px-5 py-4">
                        <div class="col-span-4">
                            <div class="h-30-px w-200-px px-5 py-2 rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
    
                        <div class="col-span-8">
                            <div class="h-30-px w-full px-5 py-2 rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 bg-white px-5 py-4">
                        <div class="col-span-4">
                            <div class="h-30-px w-200-px px-5 py-2 rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
    
                        <div class="col-span-8">
                            <div class="h-30-px w-full px-5 py-2 rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 bg-alternate px-5 py-4">
                        <div class="col-span-4">
                            <div class="h-30-px w-200-px px-5 py-2 rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
    
                        <div class="col-span-8">
                            <div class="h-30-px w-full px-5 py-2 rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 bg-white px-5 py-4">
                        <div class="col-span-4">
                            <div class="h-30-px w-200-px px-5 py-2 rounded-full">
                                <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                            </div>
                        </div>
    
                        <div class="col-span-8">
                            <div class="flex flex-col space-y-2">
                                <div class="h-30-px w-full px-5 py-2 rounded-full">
                                    <app-loader [border_radius_class]="'rounded-full'" [additional_class]=""></app-loader>
                                </div>
                                <div class="h-30-px w-full px-5 py-2 rounded-full">
                                    <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 bg-alternate px-5 py-4">
                        <div class="col-span-4">
                            <div class="text-main-gray rubik font-normal not-italic fs-14-px">
                              Description
                            </div>
                        </div>
    
                        <div class="col-span-8">
                            <ng-container *ngFor="let item of [1,2,3,5]">
                               <div class="flex flex-col">
                                <div class="h-30-px w-full px-5 py-2 rounded-full">
                                    <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                                </div>
                                <div class="h-30-px w-full px-5 py-2 rounded-full">
                                    <app-loader [border_radius_class]="'rounded-lg'" [additional_class]=""></app-loader>
                                </div>
                               </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Empty states -->
    <ng-container *ngIf="isSponsorEmpty">
        <div class="py-36">
            <div class="flex justify-center mt-5">
                <svg width="206" height="116" viewBox="0 0 206 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="103" cy="110" rx="103" ry="6" fill="#E1E1E1"/>
                    <g clip-path="url(#clip0)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.767 35.7054C143.587 34.9119 144.167 33.9068 144.441 32.8036C144.715 31.7004 144.673 30.5431 144.32 29.4623C143.966 28.3815 143.315 27.4204 142.44 26.6875C141.565 25.9546 140.501 25.4791 139.368 25.3147L119.021 22.3771C118.824 22.3489 118.637 22.2735 118.476 22.1573C118.315 22.0412 118.185 21.8878 118.098 21.7106L108.998 3.39525C108.492 2.37634 107.709 1.51832 106.737 0.918313C105.765 0.318309 104.643 0.000305176 103.499 0.000305176C102.354 0.000305176 101.232 0.318309 100.26 0.918313C99.2883 1.51832 98.5051 2.37634 97.9993 3.39525L88.8995 21.7106C88.8115 21.8876 88.6815 22.0408 88.5206 22.1569C88.3597 22.2731 88.1728 22.3486 87.976 22.3771L67.6284 25.3147C66.4954 25.4793 65.4313 25.9549 64.5563 26.6879C63.6814 27.4209 63.0305 28.382 62.677 29.4627C62.3235 30.5435 62.2816 31.7008 62.5561 32.8039C62.8305 33.907 63.4102 34.912 64.2299 35.7054L78.9588 49.9616C79.1014 50.0997 79.2079 50.27 79.2694 50.458C79.3308 50.646 79.3453 50.846 79.3115 51.0408L75.8355 71.171C75.641 72.2906 75.7661 73.4419 76.1967 74.4946C76.6273 75.5473 77.3462 76.4594 78.2722 77.1277C79.1981 77.796 80.294 78.1939 81.436 78.2762C82.5779 78.3585 83.7203 78.1221 84.7339 77.5936L102.932 68.0885C103.108 67.9964 103.304 67.9482 103.503 67.9482C103.702 67.9482 103.898 67.9964 104.074 68.0885L122.274 77.5936C123.287 78.1215 124.429 78.3576 125.571 78.275C126.713 78.1925 127.809 77.7946 128.734 77.1264C129.66 76.4583 130.379 75.5464 130.81 74.4939C131.241 73.4415 131.366 72.2905 131.172 71.171L127.696 51.0408C127.662 50.846 127.677 50.646 127.738 50.458C127.799 50.2699 127.906 50.0996 128.049 49.9616L142.767 35.7054ZM122.855 51.8636L126.331 71.9951C126.369 72.2188 126.344 72.4487 126.258 72.6589C126.172 72.869 126.028 73.0511 125.843 73.1844C125.658 73.3177 125.439 73.397 125.211 73.4134C124.983 73.4297 124.754 73.3824 124.552 73.2768L106.353 63.7718C105.473 63.3123 104.493 63.0721 103.499 63.0721C102.504 63.0721 101.525 63.3123 100.645 63.7718L82.4464 73.2794C82.2439 73.3848 82.0157 73.432 81.7876 73.4156C81.5595 73.3992 81.3406 73.3199 81.1556 73.1866C80.9705 73.0534 80.8266 72.8715 80.7402 72.6614C80.6537 72.4513 80.6282 72.2214 80.6664 71.9977L84.1423 51.8662C84.3105 50.8928 84.2377 49.8935 83.9304 48.9542C83.623 48.0149 83.0902 47.1638 82.3778 46.4741L67.6529 32.2179C67.4887 32.0594 67.3726 31.8584 67.3175 31.6378C67.2625 31.4171 67.2708 31.1856 67.3415 30.9694C67.4122 30.7532 67.5424 30.561 67.7175 30.4145C67.8926 30.2679 68.1056 30.1729 68.3323 30.1403L88.6787 27.2026C89.663 27.0604 90.5977 26.6828 91.4022 26.1022C92.2066 25.5217 92.8567 24.7556 93.2963 23.8702L102.396 5.5549C102.498 5.35205 102.654 5.18135 102.848 5.06202C103.042 4.94269 103.266 4.87947 103.494 4.87947C103.722 4.87947 103.946 4.94269 104.14 5.06202C104.334 5.18135 104.49 5.35205 104.592 5.5549L113.692 23.8702C114.131 24.7556 114.781 25.5217 115.586 26.1022C116.39 26.6828 117.325 27.0604 118.31 27.2026L138.656 30.1403C138.882 30.1732 139.095 30.2683 139.27 30.4148C139.445 30.5613 139.575 30.7534 139.646 30.9694C139.717 31.1855 139.725 31.4169 139.671 31.6375C139.616 31.858 139.5 32.0591 139.337 32.2179L124.612 46.4754C123.902 47.1658 123.372 48.0168 123.066 48.9553C122.761 49.8938 122.69 50.8918 122.859 51.8636H122.855ZM132.155 3.39396C131.628 3.0152 130.972 2.85929 130.33 2.96046C129.687 3.06163 129.112 3.41162 128.729 3.93356L126.125 7.4928C125.936 7.75142 125.799 8.04456 125.724 8.3555C125.648 8.66644 125.635 8.98909 125.686 9.30502C125.787 9.94306 126.14 10.515 126.666 10.8951C127.192 11.2751 127.849 11.4321 128.492 11.3315C129.135 11.2309 129.712 10.881 130.095 10.3587L132.699 6.79814C132.889 6.53951 133.025 6.24626 133.101 5.93514C133.177 5.62403 133.19 5.30117 133.14 4.985C133.09 4.66884 132.977 4.36558 132.809 4.09258C132.641 3.81957 132.42 3.58217 132.159 3.39396H132.155ZM80.8601 7.47872L78.2562 3.91946C78.068 3.65729 77.8294 3.43473 77.554 3.26465C77.2787 3.09457 76.972 2.98034 76.6519 2.92856C76.3318 2.87678 76.0045 2.88848 75.6889 2.96298C75.3734 3.03749 75.0759 3.17332 74.8136 3.36263C74.5513 3.55194 74.3294 3.79096 74.1607 4.06588C73.9921 4.3408 73.88 4.64617 73.831 4.96433C73.7821 5.28249 73.7971 5.60712 73.8753 5.91946C73.9536 6.2318 74.0935 6.52566 74.2869 6.78404L76.8909 10.3433C77.0804 10.6022 77.3195 10.8214 77.5945 10.9886C77.8694 11.1558 78.1749 11.2676 78.4934 11.3177C78.8119 11.3677 79.1372 11.355 79.4508 11.2803C79.7643 11.2056 80.06 11.0703 80.3209 10.8822C80.5818 10.6941 80.8027 10.4569 80.9712 10.1841C81.1397 9.91125 81.2524 9.60814 81.3028 9.29209C81.3533 8.97604 81.3405 8.65325 81.2652 8.34211C81.1899 8.03096 81.0536 7.73759 80.864 7.47872H80.8601ZM66.006 54.6705C65.8051 54.0564 65.3667 53.5465 64.7871 53.253C64.2074 52.9596 63.534 52.9065 62.915 53.1056L58.7016 54.4655C58.3949 54.5643 58.1107 54.7221 57.8654 54.9298C57.6201 55.1376 57.4184 55.3913 57.2719 55.6764C57.1254 55.9615 57.0369 56.2724 57.0115 56.5915C56.9861 56.9105 57.0243 57.2314 57.1239 57.5358C57.2234 57.8402 57.3825 58.1221 57.5919 58.3655C57.8012 58.6089 58.0569 58.8091 58.3442 58.9544C58.6315 59.0998 58.9448 59.1876 59.2664 59.2128C59.5879 59.238 59.9113 59.2001 60.2181 59.1013L64.4302 57.7402C64.7368 57.6414 65.0208 57.4836 65.266 57.2759C65.5112 57.0681 65.7127 56.8144 65.859 56.5294C66.0054 56.2443 66.0937 55.9334 66.1189 55.6145C66.1441 55.2955 66.1057 54.9748 66.006 54.6705ZM103.501 81.7257C102.85 81.7257 102.225 81.9823 101.765 82.439C101.305 82.8957 101.046 83.5151 101.046 84.1609V88.5648C101.046 88.8846 101.11 89.2013 101.233 89.4967C101.356 89.7922 101.537 90.0607 101.765 90.2868C101.993 90.5129 102.264 90.6923 102.561 90.8147C102.859 90.9371 103.178 91 103.501 91C103.823 91 104.142 90.9371 104.44 90.8147C104.737 90.6923 105.008 90.5129 105.236 90.2868C105.464 90.0607 105.645 89.7922 105.768 89.4967C105.891 89.2013 105.955 88.8846 105.955 88.5648V84.1635C105.955 83.8435 105.892 83.5266 105.769 83.2308C105.645 82.9351 105.465 82.6663 105.237 82.4399C105.009 82.2135 104.738 82.0339 104.44 81.9113C104.142 81.7888 103.823 81.7257 103.501 81.7257ZM148.302 54.4719L144.089 53.112C143.469 52.9126 142.795 52.9656 142.215 53.2592C141.635 53.5528 141.197 54.063 140.996 54.6776C140.795 55.2922 140.848 55.9608 141.144 56.5363C141.44 57.1119 141.954 57.5472 142.573 57.7466L146.786 59.1078C147.405 59.3073 148.079 59.2545 148.659 58.9608C149.24 58.6672 149.679 58.1569 149.88 57.5422C150.081 56.9274 150.028 56.2586 149.732 55.6828C149.436 55.107 148.922 54.6714 148.302 54.4719Z" fill="#666666"/>
                    </g>
                    <defs>
                    <clipPath id="clip0">
                    <rect width="93" height="91" fill="white" transform="translate(57)"/>
                    </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="text-main-gray rubik not-italic text-center mt-5">
                <p class="font-20-px font-semibold">No sponsors yet</p>
                <p class="font-14-px font-medium">No added any sponsors yet.</p>
            </div>
        </div>
    </ng-container>
</div>